<template>
    <component
        v-if="iconComponent"
        :is="iconComponent"
        :class="[`size_${size}`, color && `color_${color}`]"
        :style="rotate && { transform: `rotate(${rotate}deg)` }"
        v-tippy="tooltip"
        aria-hidden="true"
        tabindex="-1" />
</template>
<script lang="ts">
    import { defineComponent, PropType, computed, h } from 'vue';
    import { Type, Color, Background, Size, iconTypes } from './Icon.interfaces';
    import * as Icons from './Icon.imports';
    export default defineComponent({
        name: 'Icon',
        props: {
            type: { type: String as PropType<Type | null>, required: true },
            size: { type: String as PropType<Size>, default: 's' },
            tooltip: String,
            color: String as () => Color,
            background: String as () => Background,
            rotate: Number,
        },
        setup(props) {
            const getBackgroundColor = () => {
                switch (props.background) {
                    case 'white':
                        return '#fff';
                    default:
                        return 'transparent';
                }
            };
            const getComponent = (type: Type) => {
                // eslint-disable-next-line import/namespace
                const dynamicIcon = Icons[type];
                if (!dynamicIcon) {
                    console.error(`Icon component not found for type: ${type}`);
                    return null;
                }
                return {
                    render() {
                        return h(dynamicIcon, {
                            class: 'icon-svg',
                            backgroundColor: getBackgroundColor(),
                        });
                    },
                };
            };
            return {
                iconComponent: computed(() =>
                    props.type && iconTypes.includes(props.type)
                        ? getComponent(props.type)
                        : null
                ),
            };
        },
    });
</script>
<style lang="scss" scoped>
    @forward './Icon.scss';
</style>
